<template>
  <svg
    id="video-fps"
    x="0px"
    y="0px"
    viewBox="28 30 360 360"
    style="enable-background:new 28 30 360 360;"
    ref="svgVideo"
    
  >
    <title>Integrated circuit 2: 4K video at 60 frames per second</title>
    <defs>
      <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="50.68664%" id="radialGradient-1">
        <stop stop-color="#FFFFFF" offset="0%" />
        <stop stop-color="#FFFFFF" offset="100%" />
      </radialGradient>
      <filter
        x="-30.0%"
        y="-30.0%"
        width="160.0%"
        height="160.0%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feGaussianBlur stdDeviation="1" in="SourceGraphic" />
      </filter>
    </defs>
    <g>
      <text
        role="presentation"
        aria-hidden="true"
        transform="matrix(1 0 0 1 164.3703 204.0001)"
        id="framesPerSec"
        class="st0 st1 st2"
      >00</text>
      <text
        role="presentation"
        aria-hidden="true"
        transform="matrix(1 0 0 1 176.8406 241.433)"
        class="st0 st1 st3"
      >FPS</text>
      <text
        role="presentation"
        aria-hidden="true"
        transform="matrix(1 0 0 1 129.8611 109.0941)"
        class="st0 st1 st3"
      >4K video at</text>
      <path
        class="st4"
        d="M139.6,253.2V138.7c0-1.4,1.1-2.5,2.5-2.5h126.6c1.4,0,2.5,1.1,2.5,2.5v114.4c0,1.4-1.1,2.5-2.5,2.5H142.1
C140.7,255.7,139.6,254.6,139.6,253.2z"
      />
      <line class="st4" x1="189.4" y1="267.3" x2="189.4" y2="255.7" />
      <line class="st4" x1="173.4" y1="267.3" x2="173.4" y2="255.7" />
      <line class="st4" x1="205.4" y1="267.3" x2="205.4" y2="255.7" />
      <line class="st4" x1="221.4" y1="267.3" x2="221.4" y2="255.7" />
      <line class="st4" x1="253.4" y1="267.3" x2="253.4" y2="255.7" />
      <line class="st4" x1="237.4" y1="267.3" x2="237.4" y2="255.7" />
      <line class="st4" x1="157.4" y1="267.3" x2="157.4" y2="255.7" />
      <line class="st4" x1="189.4" y1="136.2" x2="189.4" y2="124.7" />
      <line class="st4" x1="173.4" y1="136.2" x2="173.4" y2="124.7" />
      <line class="st4" x1="205.4" y1="136.2" x2="205.4" y2="124.7" />
      <line class="st4" x1="221.4" y1="136.2" x2="221.4" y2="124.7" />
      <line class="st4" x1="253.4" y1="136.2" x2="253.4" y2="124.7" />
      <line class="st4" x1="237.4" y1="136.2" x2="237.4" y2="124.7" />
      <line class="st4" x1="157.4" y1="136.2" x2="157.4" y2="124.7" />
      <line class="st4" x1="197.4" y1="136.2" x2="197.4" y2="124.7" />
      <line class="st4" x1="181.4" y1="136.2" x2="181.4" y2="124.7" />
      <line class="st4" x1="213.4" y1="136.2" x2="213.4" y2="124.7" />
      <line class="st4" x1="229.4" y1="136.2" x2="229.4" y2="124.7" />
      <line class="st4" x1="261.4" y1="136.2" x2="261.4" y2="124.7" />
      <line class="st4" x1="245.4" y1="136.2" x2="245.4" y2="124.7" />
      <line class="st4" x1="165.4" y1="136.2" x2="165.4" y2="124.7" />
      <line class="st4" x1="149.4" y1="136.2" x2="149.4" y2="124.7" />
      <polyline class="st4" points="213.4,255.7 213.4,294 238.5,319.1 238.5,359.4 " />
      <line class="st4" x1="128" y1="195" x2="139.6" y2="195" />
      <line class="st4" x1="128" y1="203" x2="139.6" y2="203" />
      <line class="st4" x1="128" y1="211" x2="139.6" y2="211" />
      <line class="st4" x1="128" y1="219" x2="139.6" y2="219" />
      <line class="st4" x1="128" y1="227" x2="139.6" y2="227" />
      <line class="st4" x1="128" y1="235" x2="139.6" y2="235" />
      <line class="st4" x1="128" y1="147" x2="139.6" y2="147" />
      <line class="st4" x1="128" y1="155" x2="139.6" y2="155" />
      <line class="st4" x1="128" y1="163" x2="139.6" y2="163" />
      <line class="st4" x1="128" y1="187" x2="139.6" y2="187" />
      <line class="st4" x1="128" y1="179" x2="139.6" y2="179" />
      <line class="st4" x1="128" y1="171" x2="139.6" y2="171" />
      <line class="st4" x1="282.8" y1="195" x2="271.2" y2="195" />
      <line class="st4" x1="282.8" y1="203" x2="271.2" y2="203" />
      <line class="st4" x1="282.8" y1="211" x2="271.2" y2="211" />
      <line class="st4" x1="282.8" y1="219" x2="271.2" y2="219" />
      <line class="st4" x1="282.8" y1="227" x2="271.2" y2="227" />
      <line class="st4" x1="282.8" y1="235" x2="271.2" y2="235" />
      <line class="st4" x1="282.8" y1="147" x2="271.2" y2="147" />
      <line class="st4" x1="282.8" y1="155" x2="271.2" y2="155" />
      <line class="st4" x1="282.8" y1="163" x2="271.2" y2="163" />
      <line class="st4" x1="282.8" y1="187" x2="271.2" y2="187" />
      <line class="st4" x1="282.8" y1="179" x2="271.2" y2="179" />
      <line class="st4" x1="282.8" y1="171" x2="271.2" y2="171" />
      <circle class="st4" cx="205.4" cy="318.1" r="13.2" />
      <circle class="st4" cx="205.4" cy="318.1" r="9.4" />
      <circle class="st4" cx="305.2" cy="274.5" r="13.2" />
      <circle class="st4" cx="305.2" cy="274.5" r="9.4" />
      <path
        class="st4"
        d="M378.3,196.3h-28.8c-1.2,0-2.1-0.9-2.1-2.1v-26.5c0-1.2,0.9-2.1,2.1-2.1h28.8c1.2,0,2.1,0.9,2.1,2.1v26.5
C380.4,195.3,379.5,196.3,378.3,196.3z"
      />
      <path
        class="st4"
        d="M378.3,156.9h-28.8c-1.2,0-2.1-0.9-2.1-2.1v-26.5c0-1.2,0.9-2.1,2.1-2.1h28.8c1.2,0,2.1,0.9,2.1,2.1v26.5
C380.4,155.9,379.5,156.9,378.3,156.9z"
      />
      <path
        class="st4"
        d="M337.5,196.3h-26.8c-1.2,0-2.1-0.9-2.1-2.1v-26.5c0-1.2,0.9-2.1,2.1-2.1h26.8c1.2,0,2.1,0.9,2.1,2.1v26.5
C339.6,195.3,338.7,196.3,337.5,196.3z"
      />
      <path
        class="st4"
        d="M337.5,156.9h-26.8c-1.2,0-2.1-0.9-2.1-2.1v-26.5c0-1.2,0.9-2.1,2.1-2.1h26.8c1.2,0,2.1,0.9,2.1,2.1v26.5
C339.6,155.9,338.7,156.9,337.5,156.9z"
      />
      <path
        class="st4"
        d="M378.3,235.7h-28.8c-1.2,0-2.1-0.9-2.1-2.1v-26.5c0-1.2,0.9-2.1,2.1-2.1h28.8c1.2,0,2.1,0.9,2.1,2.1v26.5
C380.4,234.8,379.5,235.7,378.3,235.7z"
      />
      <path
        class="st4"
        d="M337.5,235.7h-26.8c-1.2,0-2.1-0.9-2.1-2.1v-26.5c0-1.2,0.9-2.1,2.1-2.1h26.8c1.2,0,2.1,0.9,2.1,2.1v26.5
C339.6,234.8,338.7,235.7,337.5,235.7z"
      />
      <polyline class="st4" points="229.4,255.7 229.4,290 254.5,315.1 254.5,359.4 " />
      <polyline class="st4" points="245.4,255.7 245.4,286 270.5,311.1 270.5,359.4 " />
      <polyline class="st4" points="261.4,255.7 261.4,282 286.5,307.1 286.5,359.4 " />
      <polyline class="st4" points="197.4,255.7 197.4,294 172.3,319.1 172.3,360.4 " />
      <polyline class="st4" points="181.4,255.7 181.4,290 156.3,315.1 156.3,360.4 " />
      <polyline class="st4" points="165.4,255.7 165.4,286 140.3,311.1 140.3,360.4 " />
      <polyline class="st4" points="149.4,255.7 149.4,282 124.3,307.1 124.3,360.4 " />
      <circle class="st4" cx="172.3" cy="364.8" r="4.5" />
      <circle class="st4" cx="195.4" cy="348.8" r="4.5" />
      <circle class="st4" cx="195.4" cy="380.9" r="4.5" />
      <circle class="st4" cx="156.3" cy="364.8" r="4.5" />
      <circle class="st4" cx="140.3" cy="364.8" r="4.5" />
      <circle class="st4" cx="124.3" cy="364.8" r="4.5" />
      <polyline class="st4" points="115,107.8 115,223.7 89.9,248.8 89.9,260.1 " />
      <circle class="st4" cx="89.9" cy="264.6" r="4.5" />
      <circle class="st4" cx="115" cy="103.3" r="4.5" />
      <polyline class="st4" points="371.5,96.6 308.7,96.6 283.6,71.5 103.5,71.5 " />
      <circle class="st4" cx="99" cy="71.5" r="4.5" />
      <circle class="st4" cx="49.9" cy="160.1" r="3.5" />
      <circle class="st4" cx="65.8" cy="160.1" r="3.5" />
      <circle class="st4" cx="33.9" cy="176" r="3.5" />
      <circle class="st4" cx="49.9" cy="176" r="3.5" />
      <circle class="st4" cx="65.8" cy="176" r="3.5" />
      <circle class="st4" cx="33.9" cy="191.9" r="3.5" />
      <circle class="st4" cx="49.9" cy="191.9" r="3.5" />
      <circle class="st4" cx="65.8" cy="191.9" r="3.5" />
      <circle class="st4" cx="33.9" cy="207.8" r="3.5" />
      <circle class="st4" cx="49.9" cy="207.8" r="3.5" />
      <circle class="st4" cx="65.8" cy="207.8" r="3.5" />
      <circle class="st4" cx="81.7" cy="160.1" r="3.5" />
      <circle class="st4" cx="81.7" cy="176" r="3.5" />
      <circle class="st4" cx="81.7" cy="191.9" r="3.5" />
      <circle class="st4" cx="81.7" cy="207.8" r="3.5" />
      <circle class="st4" cx="49.9" cy="223.7" r="3.5" />
      <circle class="st4" cx="65.8" cy="223.7" r="3.5" />
      <circle class="st4" cx="81.7" cy="223.7" r="3.5" />
      <circle class="st4" cx="97.6" cy="176" r="3.5" />
      <circle class="st4" cx="97.6" cy="191.9" r="3.5" />
      <circle class="st4" cx="97.6" cy="207.8" r="3.5" />
      <circle class="st4" cx="345.1" cy="333.8" r="3.5" />
      <circle class="st4" cx="345.1" cy="349.6" r="3.5" />
      <circle class="st4" cx="345.1" cy="365.6" r="3.5" />
      <circle class="st4" cx="360.9" cy="333.8" r="3.5" />
      <circle class="st4" cx="360.9" cy="349.6" r="3.5" />
      <circle class="st4" cx="360.9" cy="365.6" r="3.5" />
      <circle class="st4" cx="376.9" cy="317.8" r="3.5" />
      <circle class="st4" cx="360.9" cy="317.8" r="3.5" />
      <circle class="st4" cx="360.9" cy="381.5" r="3.5" />
      <circle class="st4" cx="376.9" cy="333.8" r="3.5" />
      <circle class="st4" cx="376.9" cy="349.6" r="3.5" />
      <circle class="st4" cx="376.9" cy="365.6" r="3.5" />
      <circle class="st4" cx="376.9" cy="381.5" r="3.5" />
      <polyline class="st4" points="371.5,80.6 311.7,80.6 286.6,55.5 70.2,55.5 " />
      <circle class="st4" cx="65.8" cy="55.5" r="4.5" />
      <circle class="st4" cx="375.9" cy="96.6" r="4.5" />
      <circle class="st4" cx="375.9" cy="80.6" r="4.5" />
      <circle class="st4" cx="375.9" cy="64.6" r="4.5" />
      <circle class="st4" cx="352.8" cy="266.8" r="4.5" />
      <circle class="st4" cx="336.8" cy="266.8" r="4.5" />
      <circle class="st4" cx="312.5" cy="373.6" r="4.5" />
      <circle class="st4" cx="312.5" cy="342.3" r="4.5" />
      <polyline class="st4" points="352.8,271.3 352.8,301.3 328.5,325.6 328.5,357.6 315.6,370.5 " />
      <polyline class="st4" points="336.8,271.3 336.8,298.3 312.5,322.6 312.5,337.8 " />
      <polyline class="st4" points="371.5,64.6 314.7,64.6 289.6,39.5 70.2,39.5 " />
      <circle class="st4" cx="65.8" cy="39.5" r="4.5" />
      <circle class="st4" cx="286.5" cy="363.8" r="4.5" />
      <circle class="st4" cx="270.5" cy="363.8" r="4.5" />
      <circle class="st4" cx="254.5" cy="363.8" r="4.5" />
      <circle class="st4" cx="238.5" cy="363.8" r="4.5" />
      <line class="st4" x1="195.4" y1="353.3" x2="195.4" y2="376.4" />
      <circle class="st4" cx="215.4" cy="348.8" r="4.5" />
      <circle class="st4" cx="215.4" cy="380.9" r="4.5" />
      <line class="st4" x1="215.4" y1="353.3" x2="215.4" y2="376.4" />
      <circle class="st4" cx="326.3" cy="39.6" r="4.5" />
      <circle class="st4" cx="375.9" cy="39.6" r="4.5" />
      <line class="st4" x1="330.7" y1="39.6" x2="371.5" y2="39.6" />
      <circle class="st4" cx="34.5" cy="126.3" r="4.5" />
      <circle class="st4" cx="88.6" cy="126.3" r="4.5" />
      <line class="st4" x1="38.9" y1="126.3" x2="84.1" y2="126.3" />
      <circle class="st4" cx="78.6" cy="110.4" r="4.5" />
      <circle class="st4" cx="34.9" cy="39.5" r="4.5" />
      <polyline class="st4" points="34.9,43.9 34.9,110.4 74.1,110.4 " />
      <g>
        <path
          class="st4"
          d="M46,369.9v-90.5c0-1.4,1.1-2.5,2.5-2.5H78c1.4,0,2.5,1.1,2.5,2.5v90.5c0,1.4-1.1,2.5-2.5,2.5H48.5
C47.1,372.4,46,371.3,46,369.9z"
        />
        <line class="st4" x1="71.3" y1="385" x2="71.3" y2="372.4" />
        <line class="st4" x1="71.3" y1="276.9" x2="71.3" y2="265.3" />
        <line class="st4" x1="63.3" y1="276.9" x2="63.3" y2="265.3" />
        <line class="st4" x1="30.4" y1="284.6" x2="46" y2="284.6" />
        <line class="st4" x1="34.5" y1="292.6" x2="46" y2="292.6" />
        <line class="st4" x1="30.4" y1="300.6" x2="46" y2="300.6" />
        <line class="st4" x1="30.4" y1="364.6" x2="46" y2="364.6" />
        <line class="st4" x1="34.5" y1="356.6" x2="46" y2="356.6" />
        <line class="st4" x1="34.5" y1="308.6" x2="46" y2="308.6" />
        <line class="st4" x1="92.1" y1="284.6" x2="80.6" y2="284.6" />
        <line class="st4" x1="92.1" y1="292.6" x2="80.6" y2="292.6" />
        <line class="st4" x1="92.1" y1="300.6" x2="80.6" y2="300.6" />
        <line class="st4" x1="92.1" y1="364.6" x2="80.6" y2="364.6" />
        <line class="st4" x1="92.1" y1="356.6" x2="80.6" y2="356.6" />
        <line class="st4" x1="92.1" y1="308.6" x2="80.6" y2="308.6" />
        <line class="st4" x1="92.1" y1="316.6" x2="80.6" y2="316.6" />
        <line class="st4" x1="92.1" y1="324.6" x2="80.6" y2="324.6" />
        <line class="st4" x1="92.1" y1="332.6" x2="80.6" y2="332.6" />
        <line class="st4" x1="46" y1="324.6" x2="34.5" y2="324.6" />
        <line class="st4" x1="46" y1="332.6" x2="30" y2="332.6" />
        <line class="st4" x1="92.1" y1="340.6" x2="80.6" y2="340.6" />
        <line class="st4" x1="92.1" y1="348.6" x2="80.6" y2="348.6" />
        <line class="st4" x1="46" y1="316.6" x2="30.4" y2="316.6" />
        <line class="st4" x1="46" y1="340.6" x2="34.5" y2="340.6" />
        <line class="st4" x1="46" y1="348.6" x2="30" y2="348.6" />
        <line class="st4" x1="63.3" y1="372.4" x2="63.3" y2="385" />
        <line class="st4" x1="55.3" y1="276.9" x2="55.3" y2="265.3" />
        <line class="st4" x1="55.3" y1="372.4" x2="55.3" y2="385" />
      </g>
    </g>
    <circle
      class="light"
      cx="0"
      cy="0"
      r="3"
      transform="translate(-100,-100)"
      fill="url('#radialGradient-1')"
      filter="url('#filter-2')"
    />
    <polyline class="st4 slowmo" points="38.9,126.3 84.1,126.3" />
    <polyline class="st4 slowmo" points="371.5,39.6 330.7,39.6" />
    <polyline class="st4 slowmo" points="195.4,353.3 195.4,376.4" />
    <polyline class="st4 slowmo" points="215.4,353.3 215.4,376.4" />
  </svg>
</template>

<script>
import { gsap, TweenLite } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";
import { inView } from "../../helpers/inView";

gsap.registerPlugin(MotionPathPlugin);

export default {
  name: "VideoFps",
  methods: {
    getLen(path) {
      let p = document.createElementNS("http://www.w3.org/2000/svg", "path");
      p.setAttribute("d", path);
      return p.getTotalLength();
    },
    countUp() {
      let videoCount = { fps: 0 };
      let fpsEle = document.getElementById("framesPerSec");

      TweenLite.to(videoCount, 1, {
        fps: "+=60",
        roundProps: "fps",
        ease: "linear",
        onUpdate: updateHandler
      });

      function updateHandler() {
        fpsEle.textContent = ("0" + videoCount.fps).slice(-2);
      }
    },
    checkInView() {
      if (!this.hasAnimated) {
        this.hasAnimated = inView("#video-fps", this.countUp, "inBetween");
      } else {
        document.removeEventListener("scroll", this.checkInView);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {

      let paths = document.querySelectorAll("#video-fps polyline.st4");
      let light = document.querySelector("#video-fps .light");
      let lights = [];
      let mPaths = [];
      let durations = [];
      let directions = [];

      for (let path in paths) {
        if (paths.hasOwnProperty(path)) {
          let polyline = paths[path];
          let line;
          if (polyline.nodeName !== "path") {
            line = `M${paths[path].getAttribute("points")}`;
          } else {
            line = polyline.getAttribute("d");
          }
          this.getLen(line);

          let l = light.cloneNode(true);
          this.$refs.svgVideo.appendChild(l);

          lights.push(l);
          mPaths.push(line);
          if ((polyline.classList) && (polyline.classList.contains("slowmo"))) {
            durations.push(this.getLen(line) * 0.03);
          } else {
            durations.push(this.getLen(line) * 0.013);
          }
          directions.push((polyline.classList) && (polyline.classList.contains("reverse")));
        }
      }

      gsap.to(lights, {
        motionPath: {
          path: index => mPaths[index],
          start: 1,
          end: 0
        },
        duration: index => durations[index],
        stagger: { repeat: -1, each: 0.05, ease: "power2" },
        ease: "linear"
      });

      document.addEventListener("scroll", this.checkInView);
    });
  }
};
</script>

<style scoped lang="scss">
#video-fps {
  padding: 0px 10px;

  @media screen and (max-width: 767px) {
    padding: 0px 25px;
  }
}

.st0 {
  fill: #fff;
}

.st1 {
  font-family: "Verizon", Helvetica, Arial, sans-serif;
  font-weight: bold;
}

.st2 {
  font-size: 65px;
}

.st3 {
  font-size: 30px;
}

.st4 {
  fill: none;
  stroke: #fff;
  stroke-width: 2;
  stroke-miterlimit: 10;
}

.st5 {
  font-size: 40px;
}

@include media-breakpoint-down(sm) {
  #video-fps {
    display: block;
  }
}
</style>
